"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "KanbansController", {
    enumerable: true,
    get: function() {
        return KanbansController;
    }
});
const _common = require("@nestjs/common");
const _nocodbsdk = require("nocodb-sdk");
const _globalguard = require("~/guards/global/global.guard");
const _kanbansservice = require("~/services/kanbans.service");
const _extractidsmiddleware = require("~/middlewares/extract-ids/extract-ids.middleware");
const _metaapilimiterguard = require("~/guards/meta-api-limiter.guard");
const _tenantcontextdecorator = require("~/decorators/tenant-context.decorator");
const _config = require("~/interface/config");
function _ts_decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function _ts_metadata(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
function _ts_param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
let KanbansController = class KanbansController {
    async kanbanViewGet(context, kanbanViewId) {
        return await this.kanbansService.kanbanViewGet(context, {
            kanbanViewId
        });
    }
    async kanbanViewCreate(context, tableId, body, req) {
        return await this.kanbansService.kanbanViewCreate(context, {
            tableId,
            kanban: body,
            user: req.user,
            req
        });
    }
    async kanbanViewUpdate(context, kanbanViewId, body, req) {
        return await this.kanbansService.kanbanViewUpdate(context, {
            kanbanViewId,
            kanban: body,
            req
        });
    }
    constructor(kanbansService){
        this.kanbansService = kanbansService;
    }
};
_ts_decorate([
    (0, _common.Get)([
        '/api/v1/db/meta/kanbans/:kanbanViewId',
        '/api/v2/meta/kanbans/:kanbanViewId'
    ]),
    (0, _extractidsmiddleware.Acl)('kanbanViewGet'),
    _ts_param(0, (0, _tenantcontextdecorator.TenantContext)()),
    _ts_param(1, (0, _common.Param)('kanbanViewId')),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcContext === "undefined" ? Object : _config.NcContext,
        String
    ]),
    _ts_metadata("design:returntype", Promise)
], KanbansController.prototype, "kanbanViewGet", null);
_ts_decorate([
    (0, _common.Post)([
        '/api/v1/db/meta/tables/:tableId/kanbans',
        '/api/v2/meta/tables/:tableId/kanbans'
    ]),
    (0, _common.HttpCode)(200),
    (0, _extractidsmiddleware.Acl)('kanbanViewCreate'),
    _ts_param(0, (0, _tenantcontextdecorator.TenantContext)()),
    _ts_param(1, (0, _common.Param)('tableId')),
    _ts_param(2, (0, _common.Body)()),
    _ts_param(3, (0, _common.Req)()),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcContext === "undefined" ? Object : _config.NcContext,
        String,
        typeof _nocodbsdk.ViewCreateReqType === "undefined" ? Object : _nocodbsdk.ViewCreateReqType,
        typeof _config.NcRequest === "undefined" ? Object : _config.NcRequest
    ]),
    _ts_metadata("design:returntype", Promise)
], KanbansController.prototype, "kanbanViewCreate", null);
_ts_decorate([
    (0, _common.Patch)([
        '/api/v1/db/meta/kanbans/:kanbanViewId',
        '/api/v2/meta/kanbans/:kanbanViewId'
    ]),
    (0, _extractidsmiddleware.Acl)('kanbanViewUpdate'),
    _ts_param(0, (0, _tenantcontextdecorator.TenantContext)()),
    _ts_param(1, (0, _common.Param)('kanbanViewId')),
    _ts_param(2, (0, _common.Body)()),
    _ts_param(3, (0, _common.Req)()),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcContext === "undefined" ? Object : _config.NcContext,
        String,
        void 0,
        typeof _config.NcRequest === "undefined" ? Object : _config.NcRequest
    ]),
    _ts_metadata("design:returntype", Promise)
], KanbansController.prototype, "kanbanViewUpdate", null);
KanbansController = _ts_decorate([
    (0, _common.Controller)(),
    (0, _common.UseGuards)(_metaapilimiterguard.MetaApiLimiterGuard, _globalguard.GlobalGuard),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _kanbansservice.KanbansService === "undefined" ? Object : _kanbansservice.KanbansService
    ])
], KanbansController);
